import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'

interface ECGBackgroundProps {
  maxTimeInMm?: number // Duração total em mm (padrão: 62.5mm para 2.5s)
}

/**
 * Grid de fundo padrão de ECG com linhas finas e grossas
 * Representa papel milimetrado médico padrão
 *
 * Escala fixa:
 * - Small square (1mm) = 5px
 * - Large square (5mm) = 25px (5x5px)
 * - Velocidade: 25mm/s = 125px/s
 * - Voltagem: 1mV = 10mm = 50px
 *
 * Cálculo de largura:
 * - 2.5s = 62.5mm = 312.5px
 * - 10s = 250mm = 1250px
 *
 * @param maxTimeInMm - Duração total em mm (usado para calcular width fixo)
 */
export const ECGBackground = ({ maxTimeInMm = 62.5 }: ECGBackgroundProps) => {
  const theme = useTheme()
  
  // Tamanhos fixos em pixels para manter proporção correta do papel milimetrado
  const smallSquarePx = 5 // 1mm = 5px
  const largeSquarePx = 25 // 5mm = 25px (5x5px)

  // Calcular largura fixa baseada no tempo
  // 1mm = 5px, então largura = maxTimeInMm * 5
  const widthPx = maxTimeInMm * 5 // Ex: 2.5s = 62.5mm = 312.5px, 10s = 250mm = 1250px

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: `${widthPx}px`,
        height: '100%',
        backgroundImage: `
          linear-gradient(to right, ${theme.palette.ecgGridThin.main} 1px, transparent 1px),
          linear-gradient(to bottom, ${theme.palette.ecgGridThin.main} 1px, transparent 1px),
          linear-gradient(to right, ${theme.palette.ecgGridThick.main} 1px, transparent 1px),
          linear-gradient(to bottom, ${theme.palette.ecgGridThick.main} 1px, transparent 1px)
        `,
        backgroundSize: `${smallSquarePx}px ${smallSquarePx}px, ${smallSquarePx}px ${smallSquarePx}px, ${largeSquarePx}px ${largeSquarePx}px, ${largeSquarePx}px ${largeSquarePx}px`,
        backgroundPosition: '0 0, 0 0, 0 0, 0 0',
        imageRendering: 'pixelated',
        zIndex: 0
      }}
    />
  )
}
